import actions from './actions'

const outboundDepartureTimesInitialized = actions.outboundDepartureTimesInitialized
const inboundDepartureTimesInitialized = actions.inboundDepartureTimesInitialized
const updateTransfer = actions.updateTransfer

export default {
  outboundDepartureTimesInitialized,
  inboundDepartureTimesInitialized,
  updateTransfer,
}
